var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Player } from './Player';
export { BackgroundVideo } from './BackgroundVideo';
export const VideoPlayer = (_a) => {
    var videoPlayerProps = __rest(_a, []);
    switch (videoPlayerProps.contentType) {
        case 'squareVideo':
            return React.createElement(Player, Object.assign({}, videoPlayerProps, { aspectRatio: "1 / 1" }));
        case 'verticalVideo':
            return React.createElement(Player, Object.assign({}, videoPlayerProps, { aspectRatio: "9 / 16" }));
        case 'ultraWideVideo':
            return React.createElement(Player, Object.assign({}, videoPlayerProps, { aspectRatio: "21 / 9" }));
        case 'wideVideo':
        default:
            return React.createElement(Player, Object.assign({}, videoPlayerProps, { aspectRatio: "16 / 9" }));
    }
};
//# sourceMappingURL=index.js.map